import {
  Modal,
  TouchableWithoutFeedback,
  View,
  useWindowDimensions,
} from 'react-native'

type InputMultiSelectPortalProps = {
  children: React.ReactNode
  visible?: boolean
  onOverlayPress?(): void
}

export function InputMultiSelectPortal({
  children,
  visible,
  onOverlayPress,
}: InputMultiSelectPortalProps) {
  const { width, height } = useWindowDimensions()

  return (
    <Modal visible={visible} statusBarTranslucent={false} transparent>
      <TouchableWithoutFeedback
        testID="input-multi-select-(portal)"
        onPress={onOverlayPress}
      >
        <View
          style={{
            width,
            height,
            backgroundColor: 'transparent',
          }}
        >
          {children}
        </View>
      </TouchableWithoutFeedback>
    </Modal>
  )
}
